import React from "react";
import ModuleNavigation from "../ModuleNavigation";

export default function TaskModule() {
  return <ModuleNavigation moduleId="TaskModule" />;
}
